import { render, staticRenderFns } from "./JeecgDemoTabsModal.vue?vue&type=template&id=3d6dd725&scoped=true&"
import script from "./JeecgDemoTabsModal.vue?vue&type=script&lang=js&"
export * from "./JeecgDemoTabsModal.vue?vue&type=script&lang=js&"
import style0 from "./JeecgDemoTabsModal.vue?vue&type=style&index=0&id=3d6dd725&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6dd725",
  null
  
)

export default component.exports